import React from 'react';

import {
  createBlockStyleButton,
  createInlineStyleButton,
} from '@draft-js-plugins/buttons';

import EditorBoldIcon from '@atlaskit/icon/glyph/editor/bold';
import EditorBulletListIcon from '@atlaskit/icon/glyph/editor/bullet-list';
import EditorItalicIcon from '@atlaskit/icon/glyph/editor/italic';
import EditorNumberListIcon from '@atlaskit/icon/glyph/editor/number-list';
import EditorStrikethroughIcon from '@atlaskit/icon/glyph/editor/strikethrough';
import EditorUnderlineIcon from '@atlaskit/icon/glyph/editor/underline';

export const BoldButton = createInlineStyleButton({
  style: 'BOLD',
  children: <EditorBoldIcon />,
});

export const ItalicButton = createInlineStyleButton({
  style: 'ITALIC',
  children: <EditorItalicIcon />,
});

export const StrikeButton = createInlineStyleButton({
  style: 'STRIKETHROUGH',
  children: <EditorStrikethroughIcon />,
});

export const UnderlineButton = createInlineStyleButton({
  style: 'UNDERLINE',
  children: <EditorUnderlineIcon />,
});

export const NumberListButton = createBlockStyleButton({
  blockType: 'ordered-list-item',
  children: <EditorNumberListIcon />,
});

export const BulletListButton = createBlockStyleButton({
  blockType: 'unordered-list-item',
  children: <EditorBulletListIcon />,
});
